import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, IconButton, CircularProgress } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const getEnvironmentUrl = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case "development":
      return "https://metrics.vasana.ai/";
    case "staging":
      return "https://staging.metrics.vasana.ai/";
    case "production":
      return "https://production.metrics.vasana.ai/";
    default:
      return "";
  }
};

const VasanaMetrics = () => {
  const url = getEnvironmentUrl();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Box sx={{ position: "relative", height: "100vh" }}>
      <IconButton
        sx={{
          "&.MuiButtonBase-root": {
            color: "var(--primary)",
            backgroundColor: "var(--primaryLighter)",
            border: "1px solid var(--primary)",
            borderRadius: 2,
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
            zIndex: 999,
            position: "absolute",
            left: 20,
            top: 10,
          },
        }}
        onClick={() => navigate("/admin")}
      >
        <KeyboardBackspaceIcon /> Back
      </IconButton>

      {isLoading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 998,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <iframe
        title="Vasana Metrics"
        src={url}
        width="100%"
        height="100%"
        style={{ border: "none" }}
        onLoad={() => setIsLoading(false)}
      />
    </Box>
  );
};

export default VasanaMetrics;
